import * as actions from './timelog.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { RecordTimelogModel } from '@smarttask-common/src/lib/models/TimeTracking/Timelog/RecordTimelogModel';

export const timelogAdapter = createEntityAdapter<RecordTimelogModel>({
    selectId: (x) => x.timelog_id,
});
export interface TimelogState extends EntityState<RecordTimelogModel> {
    selected_timelog_id: string;
}

export const initialState: TimelogState = timelogAdapter.getInitialState({
    selected_timelog_id: undefined,
});

export function TimelogReducers(state: TimelogState = initialState, action: actions.TimelogActions) {
    switch (action.type) {
        case actions.TimelogActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_timelog_id: action.selected_timelog_id};
            return state;

        case actions.TimelogActionTypes.ADD_TIMELOG:
            return timelogAdapter.addOne(action.timelog, state);

        case actions.TimelogActionTypes.ADD_TIMELOGS:
            return timelogAdapter.addMany(action.timelogs, state);

        case actions.TimelogActionTypes.UPSERT_TIMELOG:
            return timelogAdapter.upsertOne(action.timelog, state);

        case actions.TimelogActionTypes.UPSERT_TIMELOGS:
            return timelogAdapter.upsertMany(action.timelogs, state);

        case actions.TimelogActionTypes.UPDATE_TIMELOG:
            return timelogAdapter.updateOne(action.timelog, state);

        case actions.TimelogActionTypes.UPDATE_TIMELOGS:
            return timelogAdapter.updateMany(action.timelogs, state);

        case actions.TimelogActionTypes.DELETE_TIMELOG:
            // if(state.selectedTimelogId == action.id){
            //   state.selectedTimelogId = undefined;
            // }
            return timelogAdapter.removeOne(action.id, state);

        case actions.TimelogActionTypes.DELETE_TIMELOGS:
            // if(action.ids.indexOf(state.selectedTimelogId) > -1){
            //   state.selectedTimelogId = undefined;
            // }
            return timelogAdapter.removeMany(action.ids, state);

        case actions.TimelogActionTypes.DELETE_ALL_TIMELOGS:
            return timelogAdapter.removeMany(action.ids, state);

        case actions.TimelogActionTypes.DELETE_ALL:
            return timelogAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getTimelogState = createFeatureSelector<TimelogState>('timelog');

export const { selectIds, selectEntities, selectAll, selectTotal } =
    timelogAdapter.getSelectors(getTimelogState);

const getSelectedTimelogIdState = (state: TimelogState) => {
    return state.selected_timelog_id;
};
export const getSelectedTimelogId = createSelector(getTimelogState, getSelectedTimelogIdState);

export const getSelectedTimelog = createSelector(getTimelogState, (state: TimelogState) => {
    if (state.selected_timelog_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_timelog_id];
});


